// extracted by mini-css-extract-plugin
export default {"logo":"topMenu_logo__cr6DU","text":"topMenu_text__iO0aI","container":"topMenu_container__w1c88"};